import * as yup from 'yup';
import { messages } from 'i18n';
import { customYupValidateDomain } from 'utils';
import { CarrierFormFieldsNames, FormFieldsConfig } from './types';

const { requiredField } = messages.formMessages;

export enum UrlParam {
  Id = 'id',
}

export enum FormMode {
  Create = 'create',
  Update = 'update',
}

export const formFieldsConfig: FormFieldsConfig = {
  [CarrierFormFieldsNames.Name]: {
    label: messages.carriersPage.carrierForm.labels.name,
    placeholder: messages.carriersPage.carrierForm.placeholders.name,
    name: CarrierFormFieldsNames.Name,
    id: CarrierFormFieldsNames.Name,
    optional: false,
  },
  [CarrierFormFieldsNames.Domain]: {
    label: messages.carriersPage.carrierForm.labels.domain,
    placeholder: messages.carriersPage.carrierForm.placeholders.domain,
    name: CarrierFormFieldsNames.Domain,
    id: CarrierFormFieldsNames.Domain,
    optional: true,
  },
  [CarrierFormFieldsNames.PurchasedModules]: {
    label: messages.carriersPage.carrierForm.labels.purchasedModules,
    placeholder: '',
    name: CarrierFormFieldsNames.PurchasedModules,
    id: CarrierFormFieldsNames.PurchasedModules,
    optional: true,
  },
  [CarrierFormFieldsNames.StpConfidenceThreshold]: {
    label: messages.carriersPage.carrierForm.labels.stpConfidenceThreshold,
    placeholder: '',
    name: CarrierFormFieldsNames.StpConfidenceThreshold,
    id: CarrierFormFieldsNames.StpConfidenceThreshold,
    optional: true,
  },
};

export const schema = yup
  .object()
  .shape({
    name: yup.string().required(requiredField),
    domain: yup
      .array()
      .of(
        yup
          .string()
          .default('')
          .test('customYupValidateURL', 'customYupValidateURL', customYupValidateDomain(formFieldsConfig.domain.name)),
      )
      .default([]),
    purchasedModules: yup.array().default([]),
    stpConfidenceThreshold: yup
      .number()
      .transform((value, originalValue) => (originalValue === '' ? null : value))
      .nullable()
      .min(0)
      .max(1),
  })
  .required();
